"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LineChartComponent = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
      width = _ref.width,
      height = _ref.height,
      vertical = _ref.vertical,
      color = _ref.color,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginLeft = _ref.marginLeft,
      marginBottom = _ref.marginBottom,
      verticalAlign = _ref.verticalAlign,
      layout = _ref.layout,
      align = _ref.align,
      iconType = _ref.iconType,
      iconSize = _ref.iconSize,
      xDataKey = _ref.xDataKey,
      yDataKey = _ref.yDataKey,
      wrapperStyle = _ref.wrapperStyle,
      showLegend = _ref.showLegend,
      _ref$tickFormatter = _ref.tickFormatter,
      tickFormatter = _ref$tickFormatter === void 0 ? function (tick) {
    return tick.toLocaleString();
  } : _ref$tickFormatter,
      tickFormatterX = _ref.tickFormatterX,
      tooltipLabelFormatter = _ref.tooltipLabelFormatter,
      _ref$xAxisLine = _ref.xAxisLine,
      xAxisLine = _ref$xAxisLine === void 0 ? true : _ref$xAxisLine,
      _ref$yAxisLine = _ref.yAxisLine,
      yAxisLine = _ref$yAxisLine === void 0 ? true : _ref$yAxisLine,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      heightResponsive = _ref.heightResponsive,
      labelColor = _ref.labelColor,
      domainLimit = _ref.domainLimit,
      tickCount = _ref.tickCount,
      color2 = _ref.color2,
      _ref$showLine = _ref.showLine2,
      showLine2 = _ref$showLine === void 0 ? false : _ref$showLine;

  var htmlDom = /*#__PURE__*/_react["default"].createElement(_recharts.LineChart // width={width || 500}
  // height={height || 400}
  , {
    data: data,
    margin: {
      top: marginTop || 10,
      right: marginRight || 30,
      left: marginLeft || 30,
      bottom: marginBottom || 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
    dataKey: xDataKey,
    axisLine: xAxisLine,
    tick: {
      fill: labelColor
    },
    tickFormatter: tickFormatterX
  }), /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, _extends({
    dataKey: yDataKey,
    tickFormatter: tickFormatter,
    axisLine: yAxisLine,
    tick: {
      fill: labelColor
    }
  }, domainLimit ? {
    domain: domainLimit
  } : {}, tickCount ? {
    tickCount: tickCount
  } : {})), /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    vertical: vertical,
    strokeDasharray: "4 0"
  }), /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    labelFormatter: tooltipLabelFormatter
  }), /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
    type: "monotone",
    dataKey: yDataKey,
    strokeWidth: 2,
    stroke: color
  }), showLine2 && /*#__PURE__*/_react["default"].createElement(_recharts.Line, {
    type: "monotone",
    dataKey: "value2",
    strokeWidth: 2,
    stroke: color2
  }), showLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
    iconSize: iconSize || 10,
    iconType: iconType || "center",
    verticalAlign: verticalAlign || "middle",
    layout: layout || "vertical",
    align: align || "right",
    wrapperStyle: wrapperStyle
  }));

  return isResponsive ? /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: heightResponsive
  }, htmlDom) : htmlDom;
});

var _default = LineChartComponent;
exports["default"] = _default;